import React, { useEffect } from "react";
import { CSVLink } from "react-csv";
import { toast } from "react-toastify";

import { FaFileCsv, FaSyncAlt, FaUserMd, FaPlusCircle } from "react-icons/fa";

import { CSV_HEADERS } from "../../constant";
import {
  getDoctorsSmartSheetData,
  getUsersSmartSheetData
} from "../../doctorapi";
import { CsvButton } from "../../views/dashboard/styles";
import { SideBarWrap, ListItem, ListItemParent } from "./styles";

const SideBar = ({ setisedit, setModal, checkAlldata, getAllData, setShowLoading }) => {
  useEffect(() => {}, [checkAlldata]);

  return (
    <SideBarWrap>
      <ListItemParent>Doctor</ListItemParent>
      <ListItem
        onClick={() => {
          setShowLoading(true);
          getUsersSmartSheetData()
            .then(res => {
              setShowLoading(false);
              toast.success("Users Synchronized Successfully");
            })
            .catch(err => {
              setShowLoading(false);
              toast.error("Something went wrong")
            });
        }}
      >
        <FaSyncAlt />
        Sync Users
      </ListItem>
      <ListItem
        onClick={() => {
          setShowLoading(true);
          getDoctorsSmartSheetData()
            .then(res => {
              setShowLoading(false);
              toast.success("Doctors Synchronized Successfully")
            })
            .catch(err => {
              setShowLoading(false);
              toast.error("Something went wrong")
            });
        }}
      >
        <FaUserMd />
        Sync Doctors
      </ListItem>
      {/*<ListItem*/}
      {/*  onClick={() => {*/}
      {/*    setisedit(true);*/}
      {/*    setModal(true);*/}
      {/*  }}*/}
      {/*>*/}
      {/*  <FaPlusCircle />*/}
      {/*  Add Doctors*/}
      {/*</ListItem>*/}
      {checkAlldata ? (
        <ListItem>
          <FaFileCsv />
          <CsvButton>
            <CSVLink
              data={getAllData}
              headers={CSV_HEADERS}
              filename={"Doctors.csv"}
            >
              Export Doctors Data
            </CSVLink>
          </CsvButton>
        </ListItem>
      ) : null}
    </SideBarWrap>
  );
};

export default SideBar;



// WEBPACK FOOTER //
// ./src/component/SideBar/index.js